import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Checkbox, Paper, IconButton, Chip, Button, LinearProgress, Box, Typography, TablePagination } from '@mui/material';
import { useEquipment } from '../../../../shared/context/equipmentContext';
import { useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { useUtiles } from '../../../../shared/context/utilesContext';
import { useAbility } from '../../../../shared/context/AbilityContext';

export default function ListComponent() {
    const theme = useTheme()
    const navigate = useNavigate()

    const ability = useAbility();
    const { equipments, 
        selectedEquipmentToDelete, 
        setSelectedEquipmentToDelete, 
        getEquipments, 
        loadingDeleteEquipments, 
        deleteEquipments, 
        loadingDeleteEquipment, 
        pagination, 
        setPagination,
        loadingGetEquipments 
    } = useEquipment()

    const { locationString } = useUtiles()

    useEffect(() => {
        getEquipments()
    }, [])

    const handleCheckboxChange = (id) => {
        setSelectedEquipmentToDelete(prev => {
            if (prev.includes(id)) {
                return prev.filter(itemId => itemId !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const navigateToEquipmentByHash = (hash) => {
        navigate(`/activos/equipos/update/${hash}`)
    }

    return (
        <>


            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, mt: 1, bgcolor: 'background.paper', borderRadius: '10px' }}>
                <Typography variant="body1">
                    {selectedEquipmentToDelete.length} {selectedEquipmentToDelete.length === 1 ? 'elemento seleccionado' : 'elementos seleccionados'}
                </Typography>
               {ability.can('delete', 'ASSETS.EQUIPMENTS') && <Button
                    disabled={selectedEquipmentToDelete.length === 0 || loadingDeleteEquipments}
                    size="small"
                    variant="contained"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => {
                        deleteEquipments(selectedEquipmentToDelete)
                    }}
                >
                    Eliminar seleccionados
                </Button>}
            </Box>
            {loadingDeleteEquipments || loadingGetEquipments && (
                <LinearProgress />
            )}


            <TableContainer component={Paper} sx={{ "&.MuiPaper-root": { borderRadius: '10px', boxShadow: 'none' }, height: '70vh', overflow: 'auto' }}>
                <Table sx={{ minWidth: 2800, overflowX: 'auto' }} aria-label="simple table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '50px' }}>
                               {ability.can('delete', 'ASSETS.EQUIPMENTS') && <Checkbox
                                        color="secondary"
                                        checked={equipments.length > 0 && selectedEquipmentToDelete.length === equipments.length}
                                        indeterminate={selectedEquipmentToDelete.length > 0 && selectedEquipmentToDelete.length < equipments.length}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedEquipmentToDelete(equipments.map(loc => loc.id));
                                            } else {
                                                setSelectedEquipmentToDelete([]);
                                            }
                                        }}
                                    />}
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '100px' }}>Habilitado</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '150px' }}>Fuera de servicio</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Código</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '300px' }}>Nombre</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Fabricante</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Modelo</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Serial</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Tipo de Equipo</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '450px' }}>Ubicación</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Fecha de adquisición</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Prioridad</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Clasificación 1</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Clasificación 2</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Notas</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Otro 1</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: theme.palette.background.paper, width: '200px' }}>Otro 2</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {equipments.map((equipment) => (
                            <TableRow key={equipment.id} onClick={() => ability.can('update', 'ASSETS.EQUIPMENTS') && navigateToEquipmentByHash(equipment.hash_code)} sx={{ cursor: 'pointer' }}>
                                <TableCell onClick={(e) => e.stopPropagation()}>
                                   {ability.can('delete', 'ASSETS.EQUIPMENTS') && <Checkbox
                                        color="secondary"
                                        checked={selectedEquipmentToDelete.includes(equipment.id)}
                                        onChange={() => handleCheckboxChange(equipment.id)}
                                    />}
                                </TableCell>
                                <TableCell>{equipment.enabled ? <Chip label="Si" color="success" sx={{ color: "#fff", fontWeight: 'bold' }} /> : <Chip label="No" color="error" sx={{ color: "#fff", fontWeight: 'bold' }} />}</TableCell>
                                <TableCell>{equipment.out_of_service ? <Chip label="Si" color="warning" sx={{ color: "#fff", fontWeight: 'bold' }} /> : <Chip label="No" color="success" sx={{ color: "#fff", fontWeight: 'bold' }} />}</TableCell>
                                <TableCell>{equipment.code}</TableCell>
                                <TableCell>{equipment.name}</TableCell>
                                <TableCell>{equipment.manufacturer}</TableCell>
                                <TableCell>{equipment.model}</TableCell>
                                <TableCell>{equipment.serial}</TableCell>
                                <TableCell>{equipment.type_equipment?.name}</TableCell>
                                <TableCell>{locationString(equipment.location)}</TableCell>
                                <TableCell>{equipment.date_acquisition}</TableCell>
                                <TableCell>{equipment.priority}</TableCell>
                                <TableCell>{equipment.classification1?.value}</TableCell>
                                <TableCell>{equipment.classification2?.value}</TableCell>
                                <TableCell>{equipment.notes}</TableCell>
                                <TableCell>{equipment.otro1}</TableCell>
                                <TableCell>{equipment.otro2}</TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mt: 2,  }}>
                <TablePagination
                    rowsPerPageOptions={[20, 50, 100]}
                    component="div"
                    count={pagination.count || 0}
                    rowsPerPage={pagination.per_page || 20}
                    page={(pagination.current_page || 0) - 1}
                    onPageChange={(event, newPage) => {
                        console.log(pagination)
                        setPagination({ ...pagination, current_page: newPage });
                        getEquipments({ ...pagination, page: newPage + 1 });
                    }}
                    onRowsPerPageChange={(event) => {
                        setPagination({ ...pagination, per_page: parseInt(event.target.value) });
                        getEquipments({ ...pagination, page: 1, per_page: event.target.value });
                    }}
                    labelRowsPerPage="Registros por página"
                    sx={{
                        "& .MuiTablePagination-root": {
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            mt: 2
                        }
                    }}
                />
            </Box>
        </>
    )
}